import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setGlobalContextProperty } from "datadog-loader/loader";

export const useSetExperienceGlobalContext = (
  experienceType: string,
  checkoutIntentPayload: {
    mid: string;
    cid: string;
    mor: string;
    ksi: string;
  },
  currencyCode: string
) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const { mid, cid, mor, ksi } = checkoutIntentPayload ?? {
      mid: "",
      cid: "",
    };

    if (ksi) {
      setGlobalContextProperty({
        name: "ksi",
        context: ksi,
      });
    }
    if (mid) {
      setGlobalContextProperty({
        name: "mid",
        context: mid,
      });
    }
    if (mor) {
      setGlobalContextProperty({
        name: "mor",
        context: mor,
      });
    }
    if (currencyCode) {
      setGlobalContextProperty({
        name: "currencyCode",
        context: currencyCode,
      });
    }
    if (cid) {
      setGlobalContextProperty({
        name: "cid",
        context: cid,
      });
    }
    if (experienceType) {
      setGlobalContextProperty({
        name: "experienceType",
        context: experienceType,
      });
    }
    //TODO add returned user
  }, [currencyCode, checkoutIntentPayload, i18n.language, experienceType]);
};
